export default __webpack_public_path__ + "static/media/icon-birthdays.06b67464.png";